/**
 * @generated SignedSource<<b1d4eca74fcb706de4be8132cf68695d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientResponsesActivities_root$data = {
  readonly activities: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly coachArchived: boolean;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ActivityResponseCard_activity">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ClientResponsesActivities_root";
};
export type ClientResponsesActivities_root$key = {
  readonly " $data"?: ClientResponsesActivities_root$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClientResponsesActivities_root">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "activities"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "activityTypes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "coachArchived"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": "COMPLETED_AT_DESC",
      "kind": "LocalArgument",
      "name": "orderBy"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "username"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "withAnswersOnly"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "withClientForms"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "withMealLogging"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./ClientResponsesActivitiesRefetchQuery.graphql')
    }
  },
  "name": "ClientResponsesActivities_root",
  "selections": [
    {
      "alias": "activities",
      "args": null,
      "concreteType": "ActivityConnection",
      "kind": "LinkedField",
      "name": "__ClientResponsesActivities_activities_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ActivityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Activity",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "coachArchived",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ActivityResponseCard_activity"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Root",
  "abstractKey": null
};
})();

(node as any).hash = "0c6b616af63c4239a4802ee6b796e081";

export default node;
